/**
 * Capacitor plugin provides mechanisms for opening files and previewing media. Not available on web.
 * Reference docs used to derive types & behavior:
 *   https://www.npmjs.com/package/@capacitor/file-viewer
 */

import { CapacitorPluginsBase } from "./capacitorPluginsBase";

class FileViewer extends CapacitorPluginsBase {
  async openFromUrl (url: string) {
    await this.plugins.FileViewer.openDocumentFromUrl({ url });
  }
}

export default new FileViewer();